import React, {Component} from 'react';
import Button, {ButtonGroup} from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {Grid, GridColumn} from '@atlaskit/page';
import ContentWrapper from '../../components/ContentWrapper';
import styled from 'styled-components';
import {connect} from 'react-redux';
import ReportActions from '../../redux/ReportRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import {TextField, TextAreaField, SortSelectField, TableField} from '../../components/FormFields';
import Forbidden from '../../components/Forbidden';
import {withTranslation, Trans} from 'react-i18next';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

class ReportPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      report: {
        title: '',
        description: '',
        fields: [],
        rules: []
      },
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== 'new') {
      this.props.get(this.props.match.params.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching) {
        if (!this.props.error) {
          if (prevProps.report
            && !this.props.report) {
              //отчет был удален
              this.props.history.goBack();
          } else if (this.props.match.params.id === 'new'
            && this.props.report) {
              //отчет был добавлен
              this.props.history.goBack();
          } else {
            //даные отчета загружены
            let data = {};
            Object.keys(this.state.report).map(key => data[key] = this.props.report[key])
            this.setState({
              report: data,
            });
          }
        
        } else if (!this.state.report.title) {
          //произошла ошибка - отчет не найден, другие ошибки выводим глобально
          this.props.history.goBack();
        }
    }
  }

  onDelete = e => {
    e.preventDefault();
    this.props.delete(this.props.report.id);
  }

  onCancel = e => {
    e.preventDefault();
    this.props.history.goBack();
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {report} = this.state;
    if (report.fields && report.fields.length && report.fields.length > 0 && this.props.match.params.id === 'new') {
      this.props.create(report)
    } else {
      //waranty: Должен быть вывод ошибки, так как из required для select не работает.
      
    }
  }

  onCreateNew = e => {
    e.preventDefault();
    this.props.history.replace('/reports/new');
  }

  onChange = (name, value) => {
    this.setState({
      report: {...this.state.report, [name]: value},
    });
  }

  render() {
    //name, regionId, cityId, address, iNN, kPP, salesPhone, sTOPhone, webSite, email, description
    const isNew = this.props.match.params.id === 'new';
    const {report} = this.state;
    const {
      fetching,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;

    if (!permissions) {
      return <Forbidden />;
    } else if (isNew && !permissions.create) {
      return <Forbidden />;
    }

    const disabled = fetching || !isNew;

    return (
      <ContentWrapper>
        <HeaderContainer>
          <h1>{t(isNew ? 'New report' : 'Report')}</h1>
          {!isNew && permissions.create && (
            <Button
              appearance='danger'
              onClick={this.onCreateNew}
            >
              {t('New report')}
            </Button>
          )}
        </HeaderContainer>
        <form onSubmit={this.onFormSubmit}>
          <Grid>
            <GridColumn medium={12}>
              <TextField
                name='title'
                label={t('Name')}
                placeholder={t("Enter report's name")}
                required={true}
                onChange={this.onChange}
                isDisabled={disabled}
                value={report.title}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <TextAreaField
                name='description'
                label={t('Description')}
                placeholder={t('Enter additional information')}
                onChange={this.onChange}
                isDisabled={disabled}
                value={report.description}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <SortSelectField
                name='fields'
                label={t('Select fields and its order for report')}
                placeholder={t('Select fields for report')}
                isMulty={false}
                value={report.fields}
                required={true}
                onChange={this.onChange}
                data={dictionaries.fields.data}
                fetching={dictionaries.fields.fetching}
                getData={() => getDictionaries('fields')}
                isDisabled={disabled}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <TableField
                name='rules'
                label={t('Set conditions')}
                value={report.rules}
                onChange={this.onChange}
                fields={dictionaries.fields.data && [...dictionaries.fields.data]}
                operators={dictionaries.operators.data && [...dictionaries.operators.data]}
                andOr={dictionaries.andOr.data && [...dictionaries.andOr.data]}
                getDictionaries={getDictionaries}
                disabled={disabled}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <FormFooter>
                <ButtonGroup>
                  {!isNew && permissions.delete && (
                    <Button
                      appearance='subtle'
                      isDisabled={fetching}
                      onClick={this.onDelete}
                    >
                      <span style={{color: !fetching && 'red'}}>
                        <Trans>Remove</Trans>
                      </span>
                    </Button>
                  )}
                  <Button appearance='subtle' isDisabled={fetching} onClick={this.onCancel}>
                    <Trans>{isNew ? 'Cancel' : 'Close'}</Trans>
                  </Button>
                  {isNew && (
                    <Button type='submit' isDisabled={disabled} isLoading={fetching} appearance='danger'>
                       {t('Create')}
                    </Button>
                  )}
                </ButtonGroup>
              </FormFooter>
            </GridColumn>
          </Grid>
        </form>
      </ContentWrapper>
    );
  }
}
const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.report,
    report: state.report.data,
    fetching: state.report.fetching,
    error: state.report.error,
    dictionaries: state.dictionaries, 
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get: id => dispatch(ReportActions.reportRequest(id)),
    create: data => dispatch(ReportActions.reportAddRequest(data)),
    delete: id => dispatch(ReportActions.reportDeleteRequest(id)),
    getDictionaries: name => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('reports', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportPage));
